import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

const APP_ICON =
  "https://customer-assets.emergentagent.com/job_4de35adf-276c-46b8-87e3-30ca763560ff/artifacts/zfzj8jk6_Generated%20image%201%20%282%29.png";

const Shell = ({ title, kicker, children, testid, path }) => (
  <div className="min-h-screen bg-[#050B14] text-white" data-testid={testid}>
    <SEO
      title={`${title} · ClydeFlow`}
      description={`${kicker}. ClydeFlow is the AI automation suite for solo-founders and local business owners.`}
      path={path || "/"}
    />
    <div className="px-6 lg:px-10 pt-6">
      <Link to="/" className="inline-flex items-center gap-3" data-testid="legal-brand">
        <img
          src={APP_ICON}
          alt="ClydeFlow app icon"
          width="44"
          height="44"
          className="h-11 w-11 rounded-xl"
          data-testid="legal-app-icon"
        />
        <span className="font-heading text-2xl font-extrabold tracking-tight text-white">
          Clyde<span className="text-cyan-300">Flow</span>
        </span>
      </Link>
    </div>
    <main className="max-w-3xl mx-auto px-6 py-16 lg:py-24">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-400 mb-4">{kicker}</p>
      <h1 className="font-heading text-4xl lg:text-5xl font-black tracking-tighter">{title}</h1>
      <div className="mt-8 space-y-6 text-slate-300 leading-relaxed text-base">{children}</div>
      <div className="mt-16 pt-8 border-t border-white/10 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
        Updated · {new Date().toLocaleDateString()}
      </div>
    </main>
  </div>
);

export default Shell;
